<template>
  <a
    :href="ruta"
    class="           
    prop-item flex flex-col
    text-center 
    items-center w-fit group"      
  >
    <div
      class="           
      icono flex
      text-center
      justify-center
      content-center
      bg-transparent
      m-4 "
    >
      <base-icon
        :icon-name="icono"
        :view-box="viewBox"
        class=" inline-block text-colorIcon group-hover:text-hoverIcon"
        width="100%"
        height="100%"
        :style="{'--iconHoberColor': color, '--iconColor':'rgba(235, 124, 40, 1)'}"
      >
        <slot></slot>
      </base-icon>
    </div>
    <div 
      class="text w-full m-1 px-2 font-heading font-light group-hover:text-gray-200" 
      :style="{'background-color': color}"
    >
      {{ text1 }}
    </div>
    <div
      v-if="doble" 
      class="text w-full px-2 font-heading font-light group-hover:text-gray-200 " 
      :style="{'background-color': color}"
    >
      {{ text2 }}
    </div>
  </a>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      requiered: false,
      default: ""
    },
    icono:{
      type: String,
      requiered: false,
      default: "Dice"
    },
    text1:{
      type: String,
      requiered: false,
      default: "Dice"
    },
    text2:{
      type: [String, null],
      requiered: false,
      default: "Dice"
    },
    doble:{
      type: Boolean,
      requiered: false,
      default: false
    },
    viewBox: {
      type: String,
      requiered:false,
      default: "0 0 70 70"
    },
    ruta: {
      type: String,
      requiered: false,
      default: "Dibujo1.pdf"
    }
  },
  data () {
  return {
    publicPath: process.env.BASE_URL 
  }
},
mounted() {
  console.log(this.publicPath)
}
};
</script>

<style scoped>

  .icono {
    height: 6rem;
  }

  .text{
    color: rgba(249, 245, 234, 1);      
    border-radius: 0px 6px;
    font-size: 7vw ;    
    Line-height: 1rem;
    padding: 1rem 2rem;
  }

@media screen and (min-width: 300px) { 
  .icono {
    height: 8rem;
  }

  .text {
    font-size: 2.5rem;
    Line-height: 3rem;
    padding: 1rem 2rem;
  }
}

@media screen and (min-width: 480px) { 
  
  .icono {
    height: 4rem;
  }

  .text {
    font-size: 16px;
    Line-height: 25px;
  }
}

@media screen and (min-width: 1300px) { 
  
  .icono {
    height: 8rem;
    margin: 2.5rem;
  }

  .text {
    font-size: 2.5rem;
    Line-height: 2.5rem;
  }
}


</style>